import React, { useEffect, useState } from 'react'
import { Row, Col, Card } from 'react-bootstrap';
import AddIcon from '@material-ui/icons/Add'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import IconButton from '@material-ui/core/IconButton'
import PropTypes from 'prop-types'
import Switch from '@material-ui/core/Switch'
import TextField from '@material-ui/core/TextField'
import Tooltip from '@material-ui/core/Tooltip'
import LiveVisualizer from './liveVisualizer';
import DatePicker from 'react-date-picker';
import moment from 'moment';
import "./style.scss"

const AddDialog = props => {
    const { addHandler, surveyTemplates, surveyQuestions } = props;
    const [searchValue, setSearchValue] = React.useState('');
    const [searchResults, setSearchResults] = React.useState(surveyTemplates);
    const [currentSurvey, setCurrentSurvey] = React.useState(surveyTemplates[0]);
    const [currentQuestions, setCurrentQuestions] = React.useState(surveyQuestions.filter(q => q.survey.id === surveyTemplates[0].id).sort((a, b) => a.order - b.order));
    const [data, setData] = React.useState(null);
    const [open, setOpen] = React.useState(false);

    const initialDates = {
        showOn: new Date(),
        expireOn: new Date(moment().add(7, 'days'))
    }
    const [dates, setDates] = React.useState(initialDates);

    useEffect(() => {
        if (currentSurvey) {
            setData({
                ...currentSurvey,
                questions: currentQuestions,
                selected: currentQuestions[0] ? currentQuestions[0].question : null,
                selectedIndex: 0
            })
        }
    }, [currentSurvey])

    const [switchState, setSwitchState] = React.useState({
        addMultiple: false,
    })

    const handleSwitchChange = name => event => {
        setSwitchState({ ...switchState, [name]: event.target.checked })
    }

    const resetSwitch = () => {
        setSwitchState({ addMultiple: false })
    }

    const handleClickOpen = () => {
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
        resetSwitch()
    }

    const handleAdd = event => {
        props.setShowToast("Survey Added to Patient");
        const { showOn, expireOn } = dates;
        const showOn_formatted = showOn.getTime() * 1000;
        const expireOn_formatted = expireOn.getTime() * 1000;
        const formatted = { showOn: showOn_formatted, expireOn: expireOn_formatted };
        addHandler(currentSurvey, formatted);
        setSearchValue('')
        switchState.addMultiple ? setOpen(true) : setOpen(false)
    }

    const handleChange = () => ({ target: { value } }) => {
        setSearchValue(value);
        setSearchResults(surveyTemplates.filter(s => s.label.toUpperCase().includes(value.toUpperCase())));
    }

    const handleCurrentSurvey = (survey) => {
        const tmp = surveyQuestions.filter(q => q.survey.id === survey.id).sort((a, b) => a.order - b.order);
        setCurrentQuestions(tmp);
        setCurrentSurvey(survey);
    }

    const changeQuestion = (_question, index) => {
        setData({
            ...data,
            selected: _question,
            selectedIndex: index
        })
    }

    const handleDates = (field, value) => {
        setDates({ ...dates, [field]: value });
    }

    return (
        <div>
            <button className="mb-3 nav-btn" onClick={handleClickOpen}>Add New Survey</button>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
                fullScreen
                className="m-4 rounded"
            >
                {/* <DialogTitle id="form-dialog-title">Assign Survey to Patient</DialogTitle> */}
                <DialogContent>
                    <Row>
                        <Col md={6}>
                            <div className="title-container">
                                <Card.Title className="dashboard-card-title" id="form-dialog-title">Available Surveys</Card.Title>
                                <Card.Subtitle className="dashboard-card-sub">
                                    Browse for Surveys | Click Any to Preview
                            </Card.Subtitle>
                            </div>
                            <Card className="dashboard-card">
                                <Row className="mb-3">
                                    <Col lg={6} className="datepicker-container">
                                        <div className="date-input">Show On: </div>
                                        <div>
                                            <DatePicker
                                                onChange={(value) => handleDates('showOn', value)}
                                                value={dates.showOn}
                                                className="date-input"
                                            />
                                        </div>
                                    </Col>
                                    <Col lg={6} className="datepicker-container">
                                        <div className="date-input">Expire On: </div>
                                        <div>
                                            <DatePicker
                                                onChange={(value) => handleDates('expireOn', value)}
                                                value={dates.expireOn}
                                                className="date-input"
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <TextField
                                            autoFocus
                                            margin="dense"
                                            label="Search Surveys"
                                            type="text"
                                            fullWidth
                                            value={searchValue}
                                            onChange={handleChange()}
                                            className="text-field"
                                        />
                                    </Col>
                                </Row>
                                <Row className="mt-3">
                                    {searchResults.map(survey => {
                                        return (
                                            <Col xs={12} key={survey.id}>
                                                <div className="template-card" onClick={() => handleCurrentSurvey(survey)}>
                                                    <div>
                                                        <div className="template-card-title">{survey.label}</div>
                                                        <div className="template-card-subtitle">{survey.type}</div>
                                                    </div>
                                                    {/* <div className="template-card-action">Click to View</div> */}
                                                </div>
                                            </Col>
                                        )
                                    })}
                                </Row>
                            </Card>
                        </Col>
                        <Col md={6}>
                            <div className="title-container">
                                <Card.Title className="dashboard-card-title" id="form-dialog-title">Preview Survey</Card.Title>
                                <Card.Subtitle className="dashboard-card-sub">
                                    Preview & Test | Click Add to Assign to Patient
                            </Card.Subtitle>
                            </div>
                            <Card className="dashboard-card">
                                <Card.Title className="dashboard-card-title">{currentSurvey.label}</Card.Title>
                                <Card.Subtitle className="dashboard-card-sub">{currentSurvey.type}</Card.Subtitle>
                                <LiveVisualizer data={data} changeQuestion={changeQuestion} />
                            </Card>
                        </Col>
                    </Row>
                </DialogContent>
                <DialogActions>
                    <Tooltip title="Add multiple">
                        <Switch
                            checked={switchState.addMultiple}
                            onChange={handleSwitchChange('addMultiple')}
                            value="addMultiple"
                            inputProps={{ 'aria-label': 'secondary checkbox' }}
                        />
                    </Tooltip>
                    <Button onClick={handleClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleAdd} color="primary">
                        Add {currentSurvey.label}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

AddDialog.propTypes = {
    addHandler: PropTypes.func.isRequired,
    surveyTemplates: PropTypes.array.isRequired,
}

export default AddDialog
